import getUuid from '../components/utils/uuid';
import '../components/utils/sendbeacon';
import CompatibleWithHelper from '../components/utils/CompatibleWithHelper';
import { get as _get } from 'lodash-es';
// import AWS from 'aws-sdk';

// const {
//   REACT_APP_AWS_ACCESS_KEY_ID,
//   REACT_APP_AWS_SECRET_ACCESS_KEY,
//   REACT_APP_AWS_REGION,
//   REACT_APP_AWS_TOPICARN,
// } = process.env;

// AWS.config = new AWS.Config();
// AWS.config.accessKeyId = REACT_APP_AWS_ACCESS_KEY_ID;
// AWS.config.secretAccessKey = REACT_APP_AWS_SECRET_ACCESS_KEY;
// AWS.config.region = REACT_APP_AWS_REGION;
// const sns = new AWS.SNS();

const cartEvents = async (
  orderCreateData,
  filteredData,
  orderId,
  CustomerID
) => {
  // orderCreateData.merchantKey = 'compatioTest-ev';
  let modifiedJsonString = JSON.stringify(orderCreateData);
  // console.log(modifiedJsonString, 'orderCreateData',orderCreateData);

  const GRAPHQL_BODY = () => {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: modifiedJsonString,
      redirect: 'follow',
    };
  };

  const callApi = await fetch(
    'https://bdgzan43s2.execute-api.us-east-2.amazonaws.com/analytics-v2-prod',
    GRAPHQL_BODY()
  )
    .then(response => response)
    .then(result => {
      // if (result.ok == true) {
      //   localStorage.removeItem('CompatioAppData');
      // }
    })
    .catch(error => console.log('error', error));

  // var raw = JSON.stringify(orderCreateData);
};

const publisher = async Analyticsdata => {
  var payload = {
    default: JSON.stringify(Analyticsdata),
  };
  // let topicArn = REACT_APP_AWS_TOPICARN;
  // payload = JSON.stringify(payload);

  cartEvents(Analyticsdata);
  // console.log(topicArn, 'topicArn', Analyticsdata, 'payload');
  // let resp = [];
  // let promise = new Promise((resolve, reject) => {
  //   sns.publish(
  //     {
  //       Message: payload,
  //       MessageStructure: 'json',
  //       TopicArn: topicArn,
  //     },
  //     (err, data) => {
  //       if (err) console.log(err, err.stack);
  //       else {
  //         resp = data;
  //         resolve(resp);
  //       }
  //     }
  //   );
  // });
  // let result = await promise;
  // console.log(result, 'result');
  // return result;
};

const CompatioAnalytics = {
  // TODO: Replace with real API
  analyticsApiUrl:
    'https://1smu9bkxn4.execute-api.us-east-2.amazonaws.com/analytics',

  anonymousIdKey: 'compatio-xrs-anonymous-id',

  // List of allowed event names
  events: {
    xrsCategoryClick: 'CATEGORY_CLICKED',
    xrsSortByChange: 'SORT_ORDER_CHANGED',
    xrsProductClick: 'PRODUCT_CLICKED',
    xrsAnchorclick: 'CLICK_BUILD',
    dcAnchorClick: 'BUILDER_LOADED',
    xrsCarouselclick: 'CAROUSEL_CLICKED',
    xrsBundlerClick: 'CART_ADD_BUNDLER',
    xrsAddToCartClick: 'CART_ADD_XRS',
    productDetail: 'PRODUCT_DETAILS_PAGE_VIEW',
    addToCart: 'CART_ITEM_ADDED',
    removeFromCart: 'removeFromCart',
    purchase: 'purchase',
    collectionFilterApplied: 'SORT_COLLECTION_FILTER',
    collectionProductView: 'CLICK_VIEW_COLLECTION_PRODUCT',
    RecShown: 'APPLET_LOADED',
  },

  //List of allowed click actions
  clicks: {
    xrsShowMoreClick: 'LOAD_MORE',
    xrsOpenProduct: 'GOTO_VARIANT',
    xrsOpenCategory: 'OPEN_CAT',
    xrsGotoWidget: 'GOTO_XRS',
    xrsRightScroll: 'RIGHT_CLICK',
    xrsLeftScroll: 'LEFT_CLICK',
    bundlerAddToCart: 'ADD_BUNDLER',
    bundlerLoaded: 'BUNDLER_LOADED',
    xrsAddToCart: 'ADD_XRS',
    xcsAddToCart: 'ADD_XCS',
    dcGotoWidget: 'GOTO_BUILDER',
    collectionFilterSort: 'SORT_BY_COLLECTION',
    collectionClickProduct: 'CLICK_COLLECTION_PRODUCT',
    RecShown: 'APPLET_LOADED',
    XCSLoaded: 'XCS_LOADED',
    XCSLoadedXRS: 'XCS_LOADED_XRS',
    XCSLoadedBundler: 'XCS_LOADED_BUNDLER',
  },

  /**
   * Return anonymous user id
   *
   * @returns {string}
   */
  getUserId: function() {
    let userId = localStorage.getItem(this.anonymousIdKey);

    if (!userId) {
      const userId = getUuid();
      localStorage.setItem(this.anonymousIdKey, userId);
    }

    return localStorage.getItem(this.anonymousIdKey);
  },

  track: async function(
    event,
    data,
    appName,
    modelVersion,
    modelId,
    modelShortName
  ) {
    // console.log(event, data, 'event, data', AWS.config);
    if (!this.shouldTrackThisEvent(event)) {
      return;
    }

    // Add on Compatio-specific data for certain events
    switch (event) {
      case this.events.productDetail:
      case this.events.addToCart:
      case this.events.xrsProductClick:
        data = this.addProductDetailData(data);
        break;
      default:
      // Do nothing
    }

    //const authorization = `JWT ${window.compatioConfig.compatioApiKey}`;
    const IsPlatformShopify =
      typeof _get(window, 'compatioConfig.shopify') === 'object';
    const loginCustomerId = _get(window, 'compatioConfig.shopify.customerID');
    const payload = {
      sessionID: this.getUserId(),
      timestamp: new Date().toISOString(),
      merchantKey: IsPlatformShopify
        ? _get(window, 'compatioConfig.shopify.merchantKey')
        : '',
      eventType: event,
      domainURL: IsPlatformShopify
        ? _get(window, 'compatioConfig.shopify.baseUrl')
        : '',
      platform: IsPlatformShopify ? 'Shopify' : '',
      applicationID: appName ? appName : 'xrs',
      recommendationSource: appName ? appName : 'xrs',
      recommenderInstance: null,
      eventData: data,
      modelID: modelId ? modelId : null,
      modelShortName: modelShortName ? modelShortName : null,
      modelVersion: modelVersion ? modelVersion : null,
      customerID: loginCustomerId,
    };

    //navigator.sendBeacon(this.analyticsApiUrl, JSON.stringify(payload));
    await publisher(payload);
    // console.log(payload);
  },

  shouldTrackThisEvent: function(event) {
    const onlySendXrsSpecificEvents =
      window.compatioConfig.analyticsRestrictedMode;

    switch (event) {
      case this.events.productDetail:
      case this.events.addToCart:
        if (onlySendXrsSpecificEvents && !this.isTargetProduct()) {
          return false;
        }
        break;
      default:
        return true;
    }
    return true;
  },

  addProductDetailData(data) {
    const isTargetProduct = this.isTargetProduct();

    data.isTargetProduct = isTargetProduct;

    /**
     * Only add the additional meta data if the current product is a target project, as otherwise the meta
     * data won't exist
     */
    if (isTargetProduct) {
      data.sourceProductVariantID = CompatibleWithHelper.getByKey(
        CompatibleWithHelper.keyMap.sourceMerchantProductVariantID
      );
      data.productPosition = CompatibleWithHelper.getByKey(
        CompatibleWithHelper.keyMap.productPosition
      );
      data.categoryPosition = CompatibleWithHelper.getByKey(
        CompatibleWithHelper.keyMap.categoryPosition
      );
    }

    return data;
  },

  isTargetProduct: function() {
    //return CompatibleWithHelper.isCurrentPageTargetProduct();
  },
};

// Add to global namespace so platform-specific implementations can access this
window.CompatioAnalytics = CompatioAnalytics;

// Allow platform-specific implementations to know when window.CompatioAnalytics is ready to use
if (typeof window.compatioAnalyticsLoaded === 'function') {
  window.compatioAnalyticsLoaded();
}

export default CompatioAnalytics;
